/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReqUpdateBadge = {
    id: number;
    name: string;
    description: string;
    iconUrl: string;
    type: ReqUpdateBadge.type;
};
export namespace ReqUpdateBadge {
    export enum type {
        NORMAL = 'NORMAL',
        SPECIAL = 'SPECIAL',
    }
}

